import folder from "../assets/icons/darkIcons/folder.svg";
import file from "../assets/icons/darkIcons/file-text.svg";
import chart from "../assets/icons/darkIcons/pie-chart.svg";
import users from "../assets/icons/darkIcons/users.svg";
import tresorerie from "../assets/icons/darkIcons/bar-chart.svg";
import watch from "../assets/icons/darkIcons/watch.svg";
import home from "../assets/icons/darkIcons/home.svg";
import bookUser from "../assets/icons/darkIcons/book-user.svg";
import gear from "../assets/icons/darkIcons/settings.svg";

export const dataSideBar = [
  {
    id: 1,
    title: "Dashboard",
    icon: home,
    link: "/dashboard",
    description: "Tableau de bord",
  },
  {
    id: 2,
    title: "CRM",
    icon: folder,
    link: "/crm",
    description: "CRM - Customer Relationship Management",
  },
  {
    id: 3,
    title: "Factures",
    icon: file,
    link: "/invoices",
    description: "Facturation",
  },
  {
    id: 4,
    title: "Trésorerie",
    icon: tresorerie,
    link: "/payments",
    description: "Gestion des collaborateurs",
  },
  {
    id: 5,
    title: "Production",
    icon: chart,
    link: "/productions",
    description: "Production",
  },
  {
    id: 6,
    title: "Staff",
    icon: users,
    link: "/staff",
    description: "Gestion des collaborateurs",
  },
  {
    id: 7,
    title: "Temps",
    icon: watch,
    link: "/time",
    description: "Gestion du temps",
  },{
    id: 8,
    title: "Social",
    icon: bookUser,
    link: "/social",
    description: "Espace Social",
  }, {
    id: 9,
    title: "Paramètres",
    icon: gear,
    link: "/settings",
    description: "Paramètres",
  },
];

export const dataSideBarCustomerArea = [
  {
    id: 1,
    title: "Dashboard",
    icon: home,
    link: "/customer-area/dashboard",
    description: "Tableau de bord",
  },
  {
    id: 2,
    title: "Social",
    icon: bookUser,
    link: "/customer-area/social",
    description: "Espace Social",
  },
  {
    id: 3,
    title: "Factures",
    icon: file,
    link: "/customer-area/invoices",
    description: "Espace factures",
  },
];
